import type { IconSvgProps } from '../Icon.types';

export const DangerFilled = ({ fill, width, height, className }: IconSvgProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3103 7.52156L16.4784 2.68969C16.1963 2.40924 15.815 2.25126 15.4172 2.25H8.58281C8.185 2.25126 7.80371 2.40924 7.52156 2.68969L2.68969 7.52156C2.40924 7.80371 2.25126 8.185 2.25 8.58281V15.4172C2.25126 15.815 2.40924 16.1963 2.68969 16.4784L7.52156 21.3103C7.80371 21.5908 8.185 21.7487 8.58281 21.75H15.4172C15.815 21.7487 16.1963 21.5908 16.4784 21.3103L21.3103 16.4784C21.5908 16.1963 21.7487 15.815 21.75 15.4172V8.58281C21.7487 8.185 21.5908 7.80371 21.3103 7.52156ZM11.25 7.5C11.25 7.30109 11.329 7.11032 11.4697 6.96967C11.6103 6.82902 11.8011 6.75 12 6.75C12.1989 6.75 12.3897 6.82902 12.5303 6.96967C12.671 7.11032 12.75 7.30109 12.75 7.5V12.75C12.75 12.9489 12.671 13.1397 12.5303 13.2803C12.3897 13.421 12.1989 13.5 12 13.5C11.8011 13.5 11.6103 13.421 11.4697 13.2803C11.329 13.1397 11.25 12.9489 11.25 12.75V7.5ZM12 17.25C11.7775 17.25 11.56 17.184 11.375 17.0604C11.19 16.9368 11.0458 16.7611 10.9606 16.5555C10.8755 16.35 10.8532 16.1238 10.8966 15.9055C10.94 15.6873 11.0472 15.4868 11.2045 15.3295C11.3618 15.1722 11.5623 15.065 11.7805 15.0216C11.9988 14.9782 12.225 15.0005 12.4305 15.0856C12.6361 15.1708 12.8118 15.315 12.9354 15.5C13.059 15.685 13.125 15.9025 13.125 16.125C13.125 16.4234 13.0065 16.7095 12.7955 16.9205C12.5845 17.1315 12.2984 17.25 12 17.25Z"
        fill={fill}
      />
    </svg>
  );
};
